/**
 * WalletInfoRemapper
 *
 * Maps WalletInfoDto (data layer) → WalletInfoEntity (domain).
 * Flutter source: lib/data/models/wallet_info.dart
 */
import type { WalletInfoDto } from '@/data/dtos/info/walletInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { WalletInfoEntity } from '@/domain/entities/info/walletInfoEntity';

export class WalletInfoRemapper {
  static fromDto(dto: WalletInfoDto): WalletInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): WalletInfoDto {
    return {
      coins: (data['coins'] as number | undefined) ?? 0,
      diamonds: data['diamonds'] as number | undefined,
      money: data['money'] as number | undefined,
      currency: data['currency'] as string | undefined,
      // Flutter default: false (WalletInfo({this.auto = false}))
      auto: (data['auto'] as boolean | undefined) ?? false,
    };
  }

  static fromJsonList(dataList: JsonObject[]): WalletInfoDto[] {
    return dataList.map(WalletInfoRemapper.fromJson);
  }
}
